export default __webpack_public_path__ + "pgnv-assets/2ff348d4f603927bec6b4a6374fb6ca4.png";